import React, { useEffect, useState } from "react";
import { Card, Col } from "reactstrap";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { baseUrl } from "../../../../Utils/Baseurl/Baseurl";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import CommonTable from "../../../Tables/ReactstrapTables/BasicTables/Common/CommonTable";
import { medicineTable } from "../../../../Data/Tables/ReactstrapTables/BasicTables";
import { Btn } from "../../../../AbstractElements";
import { useNavigate } from "react-router-dom";
import { log } from "node:console";
import api from "../../../../services/api";
interface CustomJwtPayload {
  id: string;
}

interface MedicineData {
  id: number;
  medicinename: string;
  description?: string;
  medicalrepid: number;
  tokenid: number;
  status: number;
  VerificationStatus: number;
  finalstatus: number;
  tokenregistration?: TokenRegistrationData;
  rejectionstatus: string;
  rejectionReason: string;
}

interface TokenRegistrationData {
  appointmentdate: string;
  tokenno: number;
  prefix: string;
}

export default function MedicineTable() {
  const navigate = useNavigate();
  const [medicines, setMedicines] = useState<MedicineData[]>([]);

  useEffect(() => {
    const fetchMedicineDetails = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("User is not logged in!");
          return;
        }

        const decoded = jwtDecode<CustomJwtPayload>(token);
        const userId = decoded.id;

        if (!userId) {
          toast.error("Invalid token, user ID not found!");
          return;
        }

        // Fetch medicine details where medicalrepid = userId
        const response = await api.get(`${baseUrl}medicinedetails/getdetails/${userId}`);

        if (response.data && Array.isArray(response.data.data)) {
          setMedicines(response.data.data);
          console.log(response.data);
        } else {
          setMedicines([]); // Set empty array instead of throwing an error
        }
      } catch (error) {
        console.error("Error fetching medicine details:", error);
        setMedicines([]); // Ensure medicines array is empty on error
      }
    };

    fetchMedicineDetails();
  }, []);
  const sortedMedicines = [...medicines].sort((a, b) => {
    const dateA = new Date(a.tokenregistration?.appointmentdate || 0).getTime();
    const dateB = new Date(b.tokenregistration?.appointmentdate || 0).getTime();
    return dateB - dateA; // Latest date first
  });

  return (
    <Col sm={12}>
      <Card>
        <CommonCardHeader title="Medicine Details" />
        <div className="table-responsive">
          <CommonTable headData={medicineTable} headRowClass="border-bottom-secondary border-top-0">
            {sortedMedicines.length > 0 ? (
              sortedMedicines.map((medicine: MedicineData, index: number) => (
                <tr key={medicine.id}>
                  <td>{index + 1}</td>
                  <td>
                    {medicine.tokenregistration?.appointmentdate
                      ? new Date(medicine.tokenregistration.appointmentdate).toLocaleDateString("en-GB")
                      : "N/A"}
                  </td>
                  <td>
                    {medicine.tokenregistration?.prefix ?? "N/A"}-{medicine.tokenregistration?.tokenno ?? "N/A"}
                  </td>
                  <td>{medicine.medicinename}</td>
                  <td>
                    <Btn
                      onClick={() =>
                        navigate(`${process.env.PUBLIC_URL}/medicinedata/${medicine.tokenid}`)
                      }
                    >
                      Certificates
                    </Btn>
                  </td>
                  <td>
                    <span
                      style={{
                        color:
                          medicine.VerificationStatus === 0
                            ? "gray"
                            : medicine.VerificationStatus === 1 && medicine.status === 0
                            ? "orange"
                            : medicine.VerificationStatus === 1 &&
                              medicine.status === 1 &&
                              medicine.finalstatus === 0
                            ? "green"
                            : medicine.VerificationStatus === 1 &&
                              medicine.status === 1 &&
                              medicine.finalstatus === 1
                            ? "green"
                            : medicine.VerificationStatus === 1 &&
                              medicine.status === 1 &&
                              medicine.finalstatus === 2
                            ? "red"
                            : medicine.VerificationStatus === 1 &&
                              medicine.status === 2
                            ? "red"
                            : "blue",
                        fontWeight: "bold",
                      }}
                    >
                      {medicine.VerificationStatus === 0
                        ? "Not Verified"
                        : medicine.VerificationStatus === 1 &&
                          medicine.status === 0 &&
                          medicine.finalstatus === 0
                        ? "Verification at Purchase Team"
                        : medicine.VerificationStatus === 1 &&
                          medicine.status === 1 &&
                          medicine.finalstatus === 0
                        ? "Approved by Purchase team"
                        : medicine.VerificationStatus === 1 &&
                          medicine.status === 1 &&
                          medicine.finalstatus === 1
                        ? "Approved by Purchase Manager"
                        : medicine.VerificationStatus === 1 &&
                          medicine.status === 1 &&
                          medicine.finalstatus === 2
                        ? `Rejected by Purchase Manager`
                        : medicine.VerificationStatus === 1 &&
                          medicine.status === 2 &&
                          medicine.finalstatus === 0
                        ? `Rejected by Purchase Team`
                        : "Unknown Status"}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="text-center">
                  No medicine details found.
                </td>
              </tr>
            )}
          </CommonTable>
        </div>
      </Card>
    </Col>
  );
}
